import { render } from "./Header.vue?vue&type=template&id=64edbf72&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=64edbf72&scoped=true&lang=css"

import exportComponent from "/home/angelkiro/Dev/SVPhysio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64edbf72"]])

export default __exports__